import { CustomElement } from '../types';

export const deserializeFromMarkdown = (markdown: string): CustomElement[] => {
  // TODO: Implement Markdown deserialization
  console.log('Deserialize from Markdown:', markdown);
  return [
    {
      type: 'paragraph',
      children: [{ text: 'Markdown deserialization not implemented yet' }],
    },
  ];
}; 